import styled, { css, keyframes } from "styled-components"
import "../../assests/styles/styles.scss";


const rotAnimation = keyframes`
 0% { transform: translateY(0) rotateY(0) translateY(0);}
 50% { transform: translateY(-50px) rotateY(0) translateY(0);}
 100% { transform: translateY(-50px) rotateY(-180deg) translateX(-8px);}
`

const rotReverseAnimation = keyframes`
 0% { transform: translateY(-50px) rotateY(-180deg) translateX(-8px);}
 50% { transform: translateY(-50px) rotateY(0) translateY(0);}
 100% {transform: translateY(0) rotateY(0) translateY(0); }
`

export const StyledUnlockButton = styled.div`
    position:relative;
    content: "Desactivar";
    margin: auto;
    margin-top:100px;
    width: 125px;
    height: 125px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction:column;
    background-color:#0ca39d;


    border: solid 8px transparent;
    box-shadow: 10px 1000px 10px  var(--background-color) inset;
    background-image: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), linear-gradient(to right, #fb7a00, #0ca39d);
    background-origin: border-box;
    
    border-radius: 5px;
    transition: all 0.8s;
    cursor: pointer;

    &:hover {
        background-image: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), linear-gradient(to left, #fb7a00, #0ca39d);
    }

    #anilla {
        position: absolute;
        content:"";
        width: 100px;
        height: 100px;
        border-radius: 50% 50% 0 0;

        border: solid 8px transparent;
        transition: 0s;
        box-shadow: 10px 1000px 10px var(--background-color) inset;
        background-image: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), linear-gradient(to right, #fb7a00, #0ca39d);
        background-origin: border-box;
        border-bottom: none;
        
        ${props => {
            if(!props.lock) return css`
            transform-origin: left top;
                animation-name: ${rotAnimation};
            `
            else return css`
                animation-name: ${rotReverseAnimation};
            `
        }}

        animation-duration: 1000ms;
        animation-fill-mode: forwards;
        animation-iteration-count: 1;

        top: -50px;
        left: 4px;
        transition: all 0.8s;
        z-index:-1;
        #smaller{
            width:10px;
            height:30px;
            position:absolute;
            right:-8px;
            bottom:0;
            background: var(--background-color);
        }
    }

    &:after {

        content:"${props => props.lock ? 'DESACTIVAR' : 'ACTIVAR'}                           ";
        white-space: pre-wrap;

        display:flex;
        flex-direction:reverse-column;
        justify-content:center;
        align-items:center;

        font-size: 16px;
        width: 16px;
        height: 8px;
        background-color: #fb7a00;
        margin: 10px auto 0;
        border-radius: 15%;
        transition: all 0.8s;
    }
`

